import { selectFromRouteSolutionDownloadDto } from '../../models';

export default selectFromRouteSolutionDownloadDto().url.toString();

